// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Isolation Units API
 * Manage isolation units, clusters and partitions.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CloudProvider } from './CloudProvider';
import {
  CloudProviderFromJSON,
  CloudProviderFromJSONTyped,
  CloudProviderToJSON,
  CloudProviderToJSONTyped,
} from './CloudProvider';
import type { Region } from './Region';
import {
  RegionFromJSON,
  RegionFromJSONTyped,
  RegionToJSON,
  RegionToJSONTyped,
} from './Region';
import type { Resources } from './Resources';
import {
  ResourcesFromJSON,
  ResourcesFromJSONTyped,
  ResourcesToJSON,
  ResourcesToJSONTyped,
} from './Resources';

/**
 *
 * @export
 * @interface IsolationUnit
 */
export interface IsolationUnit {
  /**
   *
   * @type {CloudProvider}
   * @memberof IsolationUnit
   */
  cloudProvider: CloudProvider;
  /**
   *
   * @type {string}
   * @memberof IsolationUnit
   */
  friendlyName?: string;
  /**
   *
   * @type {string}
   * @memberof IsolationUnit
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof IsolationUnit
   */
  legacyId?: string;
  /**
   *
   * @type {Array<Region>}
   * @memberof IsolationUnit
   */
  regions?: Array<Region>;
  /**
   *
   * @type {Resources}
   * @memberof IsolationUnit
   */
  resources?: Resources;
  /**
   *
   * @type {string}
   * @memberof IsolationUnit
   */
  tenancy?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof IsolationUnit
   */
  tiers?: Array<string>;
}

/**
 * Check if a given object implements the IsolationUnit interface.
 */
export function instanceOfIsolationUnit(value: object): value is IsolationUnit {
  if (!('cloudProvider' in value) || value['cloudProvider'] === undefined)
    return false;
  return true;
}

export function IsolationUnitFromJSON(json: any): IsolationUnit {
  return IsolationUnitFromJSONTyped(json, false);
}

export function IsolationUnitFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IsolationUnit {
  if (json == null) {
    return json;
  }
  return {
    cloudProvider: CloudProviderFromJSON(json['cloud_provider']),
    friendlyName:
      json['friendly_name'] == null ? undefined : json['friendly_name'],
    id: json['id'] == null ? undefined : json['id'],
    legacyId: json['legacy_id'] == null ? undefined : json['legacy_id'],
    regions:
      json['regions'] == null
        ? undefined
        : (json['regions'] as Array<any>).map(RegionFromJSON),
    resources:
      json['resources'] == null
        ? undefined
        : ResourcesFromJSON(json['resources']),
    tenancy: json['tenancy'] == null ? undefined : json['tenancy'],
    tiers: json['tiers'] == null ? undefined : json['tiers'],
  };
}

export function IsolationUnitToJSON(json: any): IsolationUnit {
  return IsolationUnitToJSONTyped(json, false);
}

export function IsolationUnitToJSONTyped(
  value?: IsolationUnit | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cloud_provider: CloudProviderToJSON(value['cloudProvider']),
    friendly_name: value['friendlyName'],
    id: value['id'],
    legacy_id: value['legacyId'],
    regions:
      value['regions'] == null
        ? undefined
        : (value['regions'] as Array<any>).map(RegionToJSON),
    resources: ResourcesToJSON(value['resources']),
    tenancy: value['tenancy'],
    tiers: value['tiers'],
  };
}
